export const kMedChronGetJobsCacheDuration = 3 * 1000

export const MED_CHRON_FOLDER_NAME = 'Medical Chronology'
